export const DefaultMapLocation = { lat: 52.2328232, lng: 20.8963912};
